import { useEffect, useState, useRef } from "react";
import { db, storage } from "./firebase.js";
import BgShape from "../images/hero/bookbg.jpg";
import { addDoc, collection, query, where, getDocs } from "firebase/firestore";
import PhoneInput from "react-phone-number-input";
import "./numberinput.css";
import {
  ref,
  uploadString,
  getDownloadURL,
  uploadBytes,
} from "firebase/storage";
import SignatureCanvas from "react-signature-canvas";
import WaitModal from "./modal.jsx";

function BookCarMid({ isModalOpen, closeModal }) {
  const sigCanvas = useRef(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [pickTime, setPickTime] = useState("");
  const [pickingTime, setPickingTime] = useState("");

  useEffect(() => {
    document.body.style.overflow = isModalOpen ? "hidden" : "auto";
  }, [isModalOpen]);

  const [checkboxState, setCheckboxState] = useState(false);

  const handleCheckboxChange = () => {
    setCheckboxState(!checkboxState);
  };

  const [price, setPrice] = useState(0);
  const [numATVs, setNumATVs] = useState(1);
  const [numKids12, setNumKids12] = useState(0);
  const [numKids4, setNumKids4] = useState(0);
  const [tourtype, settourtype] = useState(0);


  const handleNumATVsChange = (e) => {
    setNumATVs(e.target.value);
  };

  const handleNumKidsChange12 = (e) => {
    setNumKids12(e.target.value);
  };

  const handleNumKidsChange4 = (e) => {
    setNumKids4(e.target.value);
  };

  const handleTourtype = (e) => {
    settourtype(e.target.value);
  };

  useEffect(() => {
    let abc = 0;

    if (tourtype === 'Public') {
      abc = 205;
    } else if (tourtype === 'Private') {
      abc = 235;
    }
    else if (tourtype == 0) {
      setPrice(0)
      return;
    }

    const newPrice = numATVs * abc + numKids12 * 95 + numKids4 * 95;
    setPrice(newPrice);
  }, [numATVs, numKids12, numKids4, tourtype]);


  const [images, setImages] = useState([]); // State for selected images
  const [imageURLs, setImageURLs] = useState([]); // State for image URLs

  const uploadImages = async () => {
    const imageUploadPromises = images.map(async (image) => {
      const storageRef = ref(storage, `images/${image.name}`);
      await uploadBytes(storageRef, image);
      return await getDownloadURL(storageRef);
    });

    return await Promise.all(imageUploadPromises);
  };


  const [showModal, setShowModal] = useState(false);

  // Function to trigger the modal
  const handleShowModal = () => {
    setShowModal(true);
  };


  const PaymentAlert = () => {
    setTimeout(() => {
      window.location.href = `https://www.fygaro.com/en/pb/096b655f-779b-4c9b-8c04-f854187a834f/?amount=${price}`;
    }, 7000); // 5-second delay
  };



  const postBooking = async () => {
   
    //window.location.href = `https://www.fygaro.com/en/pb/096b655f-779b-4c9b-8c04-f854187a834f/?amount=${price}`;

    const dataURL = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
    console.log(dataURL);

    if (dataURL.length < 200) {
      window.alert("Please put a signature before submitting.");
      return;
    }
     
    const storageRef = ref(storage, `signatures/${new Date().getTime()}.png`);

    // Upload the Data URL as an image file
    await uploadString(storageRef, dataURL, "data_url");

    // Get the download URL
    const downloadURL = await getDownloadURL(storageRef);

    console.log(downloadURL);
     

    try {

      if (!name || !phone || !email) {
        alert("Error: Fill All Fields!");
        return;
      }

      else if (tourtype == 0) {
        window.alert('Select Tour Type First')
        return;
      }
      
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      
      const imageDownloadURLs = await uploadImages();


      await addDoc(collection(db, "atv2hr"), {
        picktime: pickTime,
        pickingtime: '10:30 Am To 12:00 Pm',
        pkg: "1.5 Hour Atv",
        type: tourtype,
        name: name,
        phone: phone,
        email: email,
        seats: numATVs,
        price:price,
        signatureDataURL: downloadURL,
        date: formattedDate,
        kids12to16: numKids12,
        kids4to11: numKids4,
        disbtn:"no",
      });

     // window.location.href = `https://www.fygaro.com/en/pb/096b655f-779b-4c9b-8c04-f854187a834f/?amount=${price}`;

     // alert(
    //    "To complete booking, Please make the payment when this page is redirected. Press ok"
    //  );

       handleShowModal()
       PaymentAlert()

      closeModal();
      document.querySelector(".booking-done").style.display = "flex";
      setPickTime("");
      setName("");
      setPhone("");
      setEmail("");
      setPickingTime("");
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  const confirmBooking = (e) => {
    e.preventDefault();
    postBooking();
  };

  const timeSlots = ["10:30 AM to 12:00 PM", "2:30 PM to 4:30 PM"];

  // Handle button click and set selected time slot
  const handleTimeSlotSelect = async (slot) => {
    try {
      // Set the selected slot in state

      // Check if date and slot are selected
      if (!pickTime) {
        alert("Please choose date first.");
        return;
      }

      setPickingTime(slot);

      // Query Firestore for bookings that match the selected slot and date
      const bookingsRef = collection(db, "atv2hr");
      const bookingsQuery = query(
        bookingsRef,
        where("picktime", "==", pickTime),
        where("pickingtime", "==", slot)
      );

      // Execute the query
      const querySnapshot = await getDocs(bookingsQuery);
      const totalSeats = querySnapshot.docs.reduce(
        (acc, doc) => acc + (Number(doc.data().seats) || 1),
        0
      );

      // Check if seats reach the limit of 10
      if (Number(totalSeats) + Number(numATVs) >= 10) {
        alert(
          "This slot for this date has been filled. Please choose another slot."
        );
        setPickingTime(""); // Clear the selected slot if it's full
      }
    } catch (error) {
      console.error("Error checking slot availability:", error);
    }
  };

  return (
    <>
      <div
        className={`booking-modal ${isModalOpen ? "active-modal" : ""}`}
        style={{ zIndex: "24" }}
      >
        <div
          className="booking-modal__title"
          style={{
            backgroundColor: "#5078f2",
            backgroundImage: "linear-gradient(315deg, #182b3a 0%, #20a4f3 74%)", marginTop:'24px'
          }}
        >
          <h2>Complete Reservation</h2>
          <button
            onClick={closeModal}
            style={{
              height: "35px",
              width: "35px",
              backgroundColor: "red",
              color: "white",
              fontSize: "22px",
              fontWeight: "bold",
            }}
          >
            X
          </button>
        </div>
        <div className="booking-modal__message">
          <h4 style={{ color: "blue" }}>
            <i className="fa-solid fa-circle-info"></i> Upon completing this
            booking form:
          </h4>
          <p>
            You will redirected to payment page, a booking will only be confirmed if you make the payment. No action needed after making the payment. Kindly always call us before arrival.
          </p>
        </div>

        <div style={{ textAlign: "center" }}>
            <label htmlFor="picktime" style={styles.label}>
              <i className="fa-regular fa-calendar-days"></i> Public or Private Use?
              <b style={{ color: "red" }}>*</b>
            </label>
            <select
              id="numKids12to16"
              value={tourtype}
              onChange={handleTourtype}
              style={{
                padding: "10px",
                fontSize: "18px",
                width: "200px",
                marginTop: "10px",
              }}
            >
                    <option value={0}>Choose Option</option>
                    <option value={'Public'}>Public Tour</option>
                    <option value={'Private'}>Private Tour</option>
            </select>
          </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
            padding: "20px",
            height: "120vh", // Center content vertically
          }}
        >
          {/* ATV Dropdown */}
          <div style={{ textAlign: "center" }}>
            <label htmlFor="picktime" style={styles.label}>
              <i className="fa-regular fa-calendar-days"></i>Number Of Adults
              <b style={{ color: "red" }}>*</b>
            </label>
            <select
              id="numATVs"
              value={numATVs}
              onChange={handleNumATVsChange}
              style={{
                padding: "10px",
                fontSize: "18px",
                width: "200px", // Wider dropdown
                marginTop: "10px",
              }}
            >
              {[...Array(10)].map((_, index) => (
                <option key={index} value={index + 1}>
                  {index + 1}
                </option>
              ))}
            </select>
          </div>

          {/* Kids Dropdown (12-16 yrs) */}
          <div style={{ textAlign: "center" }}>
            <label htmlFor="picktime" style={styles.label}>
              <i className="fa-regular fa-calendar-days"></i>Number of Kids
              (12-16 yrs)
              <b style={{ color: "red" }}>*</b>
            </label>
            <select
              id="numKids12to16"
              value={numKids12}
              onChange={handleNumKidsChange12}
              style={{
                padding: "10px",
                fontSize: "18px",
                width: "200px",
                marginTop: "10px",
              }}
            >
              {[...Array(6)].map((_, index) => (
                <option key={index} value={index}>
                  {index}
                </option>
              ))}
            </select>
          </div>

          {/* Kids Dropdown (4-11 yrs) */}
          <div style={{ textAlign: "center" }}>
            <label htmlFor="picktime" style={styles.label}>
              <i className="fa-regular fa-calendar-days"></i>Number of Kids
              (4-11 yrs)
              <b style={{ color: "red" }}>*</b>
            </label>

            <select
              id="numKids4to11"
              value={numKids4}
              onChange={handleNumKidsChange4}
              style={{
                padding: "10px",
                fontSize: "18px",
                width: "200px",
                marginTop: "10px",
              }}
            >
              {[...Array(6)].map((_, index) => (
                <option key={index} value={index}>
                  {index}
                </option>
              ))}
            </select>
          </div>

          <label htmlFor="picktime" style={styles.labelprice}>
              <i className="fa-regular fa-calendar-days"></i>Total Price: <b style={{ color: "green" }}>{price} USD</b> 
        </label>
        </div>

    

        <div style={styles.formContainer}>
          {/* Pick-up Date Picker */}
          <div style={styles.fieldContainer}>
            <label htmlFor="picktime" style={styles.label}>
              <i className="fa-regular fa-calendar-days"></i>Choose Date
              <b style={{ color: "red" }}>*</b>
            </label>
            <input
              id="picktime"
              value={pickTime}
              onChange={(e) => setPickTime(e.target.value)}
              type="date"
              style={styles.dateInput}
            />
          </div>

          {/* Time Slot Picker */}
          <label htmlFor="picktime" style={styles.label}>
            <i className="fa-regular fa-calendar-days"></i> Fixed Time Slot
           
          </label>

          
          <div style={styles.timeSlotContainer}>
<h3 style={{fontSize:'24px'}}>10:30 Am To 12:00 Pm</h3>

{/* 
            {timeSlots.map((slot) => (
              <button
                key={slot}
                onClick={() => handleTimeSlotSelect(slot)}
                style={{
                  ...styles.timeSlotButton,
                  ...(pickingTime === slot ? styles.selectedButton : {}),
                }}
              >
                {slot}
              </button>
            ))} */}

          </div>
        </div>

        <div className="booking-modal__person-info">
          <h4 style={{ color: "blue" }}>Personal Information</h4>
          <form className="info-form">
            <div className="info-form__2col">
              <span>
                <label>
                  Full Name <b>*</b>
                </label>
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  placeholder="Enter full name"
                ></input>
              </span>
              <span>
                <div className="phoneInputContainer">
                  <label className="label">
                    Phone Number <b>*</b>
                  </label>
                  <div className="phoneInputWrapper">
                    <PhoneInput
                      international
                      defaultCountry="US"
                      value={phone}
                      onChange={setPhone}
                      placeholder="Enter your phone number"
                      className="phoneInput"
                    />
                  </div>
                </div>
              </span>
            </div>
            <div className="info-form__1col">
              <span>
                <label>
                  Email <b>*</b>
                </label>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  placeholder="Enter your email address"
                ></input>
              </span>
            </div>

            <div className="info-form__1col">
              <span>
                <h4>Terms & Conditions Waiver:</h4>

                <p>
                  The Renter assumes full responsibility and releases the
                  Company from certain liabilities during the vehicle rental
                  period.
                </p>

                <h5>Responsibilities of the Renter:</h5>
                <ul>
                  <li>
                    To operate the rented vehicle in accordance with all
                    applicable laws and regulations.
                  </li>
                  <li>
                    To return the vehicle in the same condition as received,
                    excluding normal wear and tear.
                  </li>
                  <li>
                    To bear any costs related to damage, loss, or theft of the
                    vehicle during the rental period, including repairs,
                    replacement, or the deductible amount outlined in the rental
                    agreement.
                  </li>
                  <li>
                    To cover any fines or penalties from traffic violations
                    incurred while in possession of the vehicle.
                  </li>
                  <li style={{fontWeight:'bold'}}>
                    No Stunts Allowed!
                  </li>
                  <li style={{fontWeight:'bold'}}>
                    No 360 Allowed!
                  </li>
                  <li style={{fontWeight:'bold'}}>
                   No Racing Allowed!
                  </li>


                </ul>

                <p style={{fontWeight:'bold'}}>
                  The Renter releases the Company, its employees, agents,
                  representatives, and affiliates from liability for any claims,
                  damages, losses, or expenses arising from the use of the
                  rented vehicle. This includes claims for personal injury,
                  property damage, or other loss.
                </p>

                <h5>Additional Terms:</h5>
                <ul>
                  <li>
                    The Renter agrees not to make any modifications to the
                    vehicle. Unauthorized changes will be at the Renter's
                    expense.
                  </li>
                  <li>
                    This Contract is governed by the laws currently enforced in
                    the Turks and Caicos Islands, as applied by the Supreme
                    Court.
                  </li>
                  <li>
                    This Contract constitutes the entire agreement, superseding
                    any prior agreements or understandings, whether written or
                    oral.
                  </li>
                </ul>

                <p>
                  If any provision of this Contract is deemed invalid, the
                  remaining provisions will remain in full effect. The failure
                  of either party to enforce a provision will not be considered
                  a waiver of that provision or the right to enforce it.
                </p>

                <p style={{fontWeight:'bold'}}>
                Our Policy: We have 48 hours no cancellations policy! No refund for no show at the above location And time you booked for, no change date or time!
                </p>

                <p>
                  The Renter acknowledges they have read, understood, and agreed
                  to these terms and conditions.
                </p>
              </span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "5vh",
                flexDirection: "column",
              }}
            >
              <h4 style={{ textAlign: "center" }}>
                Draw Your Signature Below:
              </h4>
             
            </div>

           
               <div className="info-form__1col"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >

                  <div
                    style={{
                      height: "200px",
                      width: "310px",
                      backgroundColor: "red",
                      //border: "3px solid red",
                      borderRadius: "10px",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                     // padding: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <SignatureCanvas
                      ref={sigCanvas}
                      penColor="black"
                      canvasProps={{
                        width: 280,
                        height: 180,
                        className: "sigCanvas",
                        style: {
                          backgroundColor: "white",
                          borderRadius: "5px",
                          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                        },
                      }}
                    />
                  </div>

                  <div
                    style={{ marginTop: "20px", display: "flex", gap: "10px" }}
                  ></div>
                </div>


            <div className="reserve-button">
              <button
                onClick={confirmBooking}
                style={{
                  backgroundColor: "#182b3a",
                  backgroundImage:
                    "linear-gradient(315deg, #182b3a 0%, #20a4f3 74%)",
                }}
              >
                Reserve Now
              </button>
           
            </div>
           
          </form>
        </div>
       
      </div>
      <WaitModal show={showModal} setShow={setShowModal} />
    </>
  );
}

const styles = {
  formContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "55vh",
    backgroundColor: "#f7f9fc",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
  },
  fieldContainer: {
    marginBottom: "20px",
    textAlign: "center",
  },
  label: {
    color: "blue",
    fontSize: "2rem",
    display: "block",
    marginBottom: "8px",
    textAlign: "center",
  },
  labelprice: {
    color: "green",
    fontSize: "2.2rem",
    display: "block",
    marginBottom: "30px",
    textAlign: "center",
  },

  dateInput: {
    padding: "8px 12px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    fontSize: "1.7rem",
    textAlign: "center",
  },
  timeSlotContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    justifyContent: "center",
  },
  timeSlotButton: {
    padding: "12px 20px",
    // fontSize: "1rem",
    backgroundColor: "#d9d9d9",
    color: "#333",
    border: "2px solid #ccc",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    width: "210px",
    fontSize: "18px",
    fontWeight: "bold",
  },
  selectedButton: {
    backgroundColor: "#4caf50",
    color: "white",
    borderColor: "#4caf50",
  },
};

export default BookCarMid;